export default {
  headers: {
    expedient: 'File',
    description: 'Agreement',
    amount: 'Advance available'
  }
}
